export default __webpack_public_path__ + "static/media/icon-close-white.2a68239c.svg";